import { jsxs as t, jsx as i } from "react/jsx-runtime";
import e from "../../../svg-icon/svg-icon.component.js";
function r(l) {
  return /* @__PURE__ */ t(
    e,
    {
      width: "53",
      height: "32",
      viewBox: "0 0 53 32",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...l,
      children: [
        /* @__PURE__ */ i("rect", { width: "52.9401", height: "32", rx: "8", fill: "white" }),
        /* @__PURE__ */ t("g", { clipPath: "url(#DefaultBadgeNegative-clip0_35815_220)", children: [
          /* @__PURE__ */ i(
            "path",
            {
              d: "M8.03687 9.76514H10.943V12.6555H14.4804V15.2173H10.943V19.6302C10.943 20.5847 11.294 21.2018 12.5147 21.2018H14.4804V23.7637H12.5147C8.88737 23.7633 8.03687 21.7474 8.03687 19.458V9.76514Z",
              fill: "#FF5D47"
            }
          ),
          /* @__PURE__ */ i(
            "path",
            {
              d: "M15.6921 9.76514C15.6921 8.5703 16.7089 8.02136 17.4573 8.02136C18.4088 8.02136 19.2007 8.78192 19.2007 9.76514C19.2007 10.6042 18.5143 11.5303 17.4573 11.5303C16.2743 11.5303 15.6921 10.4925 15.6921 9.76514ZM15.9937 23.7633V12.6555H18.8999V23.7633H15.9937Z",
              fill: "#FF5D47"
            }
          ),
          /* @__PURE__ */ i(
            "path",
            {
              d: "M31.0149 14.668C30.2768 13.2907 28.8729 12.4398 27.0971 12.4398C25.0543 12.4398 23.9668 13.6756 23.6313 14.1051V12.6555H20.7251V23.7633H23.6313V17.5421C23.6313 16.5489 24.1769 15.7788 24.8692 15.4002C25.2493 15.1923 25.6766 15.0879 26.15 15.0879C26.6521 15.0879 27.0934 15.1923 27.4739 15.4002C28.2071 15.8009 28.6687 16.5482 28.6687 17.5421V23.7633H31.5749V17.0253C31.5749 16.15 31.3883 15.3644 31.0152 14.668H31.0149Z",
              fill: "#FF5D47"
            }
          ),
          /* @__PURE__ */ i(
            "path",
            {
              d: "M36.2301 19.3718C35.9897 18.7049 35.8666 17.635 36.4221 16.6164C36.928 15.6888 37.84 15.1097 38.9622 15.1097C40.2153 15.1097 41.0658 15.816 41.5023 16.6164C42.0328 17.5893 41.948 18.668 41.6944 19.3718H44.7941C44.8756 18.9523 45.1997 17.0887 44.1176 15.2818C43.0957 13.5753 41.2417 12.4402 38.9619 12.4402C36.5549 12.4402 34.7569 13.6925 33.8061 15.2818C32.7292 17.0817 33.043 18.9253 33.1296 19.3718H36.2297H36.2301Z",
              fill: "#FF5D47"
            }
          ),
          /* @__PURE__ */ i(
            "path",
            {
              d: "M33.9093 21.3091C34.8284 22.7509 36.5338 23.9786 38.9618 23.9786C41.1104 23.9786 42.9534 22.9729 44.0144 21.3091H33.9089H33.9093Z",
              fill: "#FF5D47"
            }
          )
        ] }),
        /* @__PURE__ */ i("defs", { children: /* @__PURE__ */ i("clipPath", { id: "clip0_35815_220", children: /* @__PURE__ */ i(
          "rect",
          {
            width: "36.9401",
            height: "16",
            fill: "white",
            transform: "translate(8 8)"
          }
        ) }) })
      ]
    }
  );
}
export {
  r as DefaultBadgeNegativeLogo
};
//# sourceMappingURL=negative.js.map
